import { adminConstants } from "../constant/admin-constant";

const initialState = {
    brands: []
}

export const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case adminConstants.GET_ALL_BRANDS_SUCCESS:
            return {
                ...state,
                brands: action.payload.data
            }
        case adminConstants.GET_ALL_BRANDS_FAILURE:
            return {
                ...state,
                error: action.payload
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AccountReducer.jsx